import React, { useEffect } from "react";

import style from "../assets/css/page/Login.module.css";

import { Formik, Form } from "formik";
import Input from "../components/Input/Input";
import Button from "../components/Button/Button";
import InputPass from "../components/Input/InputPass";

import { loginInitialState, loginValidationSchema } from "../utils/login";
import useLogin from "../hooks/useLogin";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useNavigate } from "react-router";

import logo from "../assets/img/badge.png";
import Loading from "../components/Loading";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);

function Login() {
  const { loadingLogin, loginUser } = useLogin();
  const [jwt, setJwt] = useLocalStorage("jwt", null);
  const [id, setId] = useLocalStorage("id", null);
  const [role, setRole] = useLocalStorage("role", null);
  const [permissions, setPermissions] = useLocalStorage("permissions", null);
  const [team, setTeam] = useLocalStorage("team", null);
  const navigate = useNavigate();

  useEffect(() => {
    if (jwt && id && role && permissions && team) {
      // console.log(role);
      if (role === "Admin") {
        navigate("/admin/control");
      } else {
        const parseTeam = JSON.parse(team);
        navigate("/team/" + parseTeam.name, {
          state: { id: parseTeam.id, pos: 1 },
        });
      }
    }
    return () => {};
  }, []);

  if (loadingLogin) {
    return <Loading />;
  }

  const handleSubmit = async (values) => {
    const { email, password } = values;
    // console.log(email);
    // console.log(password);
    const response = await loginUser({ identifier: email, password });
    if (response === "error") {
      // console.log("Verificar", "Correo o contraseña incorrecta.");
      MySwal.fire({
        icon: "error",
        title: "Verificar",
        text: "Correo o contraseña incorrecta",
      });
    } else if (response === "error-server") {
      // console.log(
      //   "Lo sentimos, esto no debió pasar",
      //   "Estamos trabajando para solucionarlo, intenta de nuevo más tarde"
      // );
      MySwal.fire({
        icon: "error",
        title: "Lo sentimos, esto no debió pasar",
        text: "Estamos trabajando para solucionarlo, intenta de nuevo más tarde",
      });
    } else {
      // console.log(response);
      setJwt(response?.jwt);
      setId(response?.id);
      setRole(response?.role?.name);
      setPermissions(JSON.stringify(response?.permissions));
      setTeam(JSON.stringify(response?.team));
      if (response?.role?.name === "Admin") {
        navigate("/admin/control", {
          state: { id: response?.team, pos: 1 },
        });
      } else {
        navigate("/team/" + response?.team?.name, {
          state: { id: response?.team?.id, pos: 1 },
        });
      }
    }
  };

  return (
    <div className={style.container}>
      <Formik
        initialValues={loginInitialState}
        validationSchema={loginValidationSchema}
        onSubmit={handleSubmit}
      >
        <Form className={style.contForm}>
          <div className={style.form}>
            <h1 className={style.title}>Iniciar sesión</h1>
            <Input name="email" title="Usuario" type="text" />
            <InputPass name="password" title="Contraseña" />
            <Button text="Ingresar" />
          </div>
        </Form>
      </Formik>
      <div className={style.contInfo}>
        <div className={style.logo}>
          <div className={style.icon}>
            <img className={style.img} src={logo} alt="" />
          </div>
          <div className={style.contName}>
            <h1 className={style.name}>
              Deportiv<span>istmo</span>
            </h1>
          </div>
        </div>
        {/* <div className={style.contForm}></div> */}
      </div>
    </div>
  );
}

export default Login;
